import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ImportList from './ImportList';
import Stations from './Stations';
import AddNewStation from './AddNewStation';
import StationDetails from './StationDetails';
import ExportStations from './ExportStations';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    float: 'left',
    '& .Mui-selected': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
    '& .MuiTabs-root': {
      minHeight: '35px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiTab-root': {
      minWidth: '150px',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      boxShadow: 'none',
      background: '#fff',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '6px 6px 0px 0px',
        minHeight: 'auto',
        borderBottom: 'none',
        color: "#333",
        padding: '5px 10px',
      }
    },
    '& h5': {
      fontSize: '16pt',
      margin: '0px 0 10px',
    }
  },
  mainBlock: {
    padding: '10px',
    position: 'absolute',
    height: '98%',
    width: '100%',
    float: 'left',
    background: '#fff',
    top: '2%',
    zIndex: '1',
    width: '100%',
    '& h4': {
      margin: '0',
      color: '#24618E',
      marginTop: '30px',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20pt',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '30pt',
      },
    },
    '& .MuiPaper-elevation2': {
      boxShadow: 'none',
    },
    '& .focus': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
  },
  tabblock: {
    border: '1px solid #24618E',
    paddingTop: '10px',
    marginBottom: '5px',
    borderRadius: '0px 5px 5px 5px',
    width: '100%',
    float: 'left',
    paddingBottom: '10px',
    '& .MuiBox-root': {
      padding: '0px 10px 10px 10px',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    }
  },
  nonTab: {
    display: 'none',
  },
  innerTabDiv: {
    width: '100%',
    float: 'left',
    // '@media only screen and (max-width: 1500px)': {
    //   height: (window.innerHeight - 200).toString() + 'px',
    // },
    // '@media only screen and (min-width: 1501px) and (max-width: 3500px)': {
    //   height: (window.innerHeight - 210).toString() + 'px',
    // },
    // '@media only screen and (min-width: 3501px)': {
    //   height: (window.innerHeight - 280).toString() + 'px',
    // },
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
  innerTabDivSecond: {
    width: '100%',
    float: 'left',
    // '@media only screen and (max-width: 1500px)': {
    //   height: (window.innerHeight - 200).toString() + 'px',
    // },
    // '@media only screen and (min-width: 1501px) and (max-width: 3500px)': {
    //   height: (window.innerHeight - 210).toString() + 'px',
    // },
    // '@media only screen and (min-width: 3501px)': {
    //   height: (window.innerHeight - 280).toString() + 'px',
    // },
    overflowX: 'hidden',
    overflowY: 'auto',
  }
}));

export default function DataManagement() {


  let dmHeight = window.innerHeight;
  sessionStorage.setItem('dmTabHeight', window.innerHeight);
  sessionStorage.setItem('dmTabWidth', window.innerWidth);

  // This code is use to get window viewport height
  if (window.screen.width >= 100 && window.screen.width <= 1500) {
    dmHeight = window.innerHeight - 200;
  }
  else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
    dmHeight = window.innerHeight - 210;
  }
  else if (window.screen.width >= 3501) {
    dmHeight = window.innerHeight - 280;
  }
  else {
    dmHeight = window.innerHeight - 200;
  }
  // This code is use to get window viewport height

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [imlTab, setImlTab] = React.useState("fo");
  const [dsTab, setDsTab] = React.useState("fo");
  const [sTab, setSTab] = React.useState("fo");
  const [screenDMHeight, setScreenDMHeight] = React.useState(dmHeight);

  // This code is use to change window viewport height
  window.onresize = function () {
    sessionStorage.setItem('dmTabHeight', window.innerHeight);
    sessionStorage.setItem('dmTabWidth', window.innerWidth);

    if (window.screen.width >= 100 && window.screen.width <= 1500) {
      dmHeight = window.innerHeight - 200;
      setScreenDMHeight(dmHeight);
    }
    else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
      dmHeight = window.innerHeight - 210;
      setScreenDMHeight(dmHeight);
    }
    else if (window.screen.width >= 3501) {
      dmHeight = window.innerHeight - 280;
      setScreenDMHeight(dmHeight);
    }
    else {
      dmHeight = window.innerHeight - 200;
      setScreenDMHeight(dmHeight);
    }
  };
  // This code is use to change window viewport height

  React.useEffect(
    () => {
      let activeTab = sessionStorage.getItem('dataActiveTab') ? parseInt(sessionStorage.getItem('dataActiveTab')) : 0;
      if (activeTab !== 0) {
        if (activeTab === 1) {
          setValue(1);
          setImlTab("unFocus");
          setSTab("focus");
        } else if (activeTab === 2) {
          setValue(2);
          setImlTab("unFocus");
          setSTab("focus");
        } else if (activeTab === 3) {
          setValue(3);
          setImlTab("unFocus");
          setSTab("focus");
        } else if (activeTab === 5) {
          setValue(5);
          setImlTab("focus");
          setSTab("unFocus");
        }
      }

      return () => {
        if (sessionStorage.getItem('dataActiveTab')) {
          sessionStorage.removeItem('dataActiveTab')
        }
      };
    }, []
  );
  //This function is for handle change Tab focusable Start
  const handleChange = (event, newValue) => {
    sessionStorage.setItem('dataActiveTab', newValue);
    setValue(newValue);
    if (newValue === 0) {
      setImlTab("focus");
      setSTab("unFocus");
      setDsTab("unFocus");
    }
    if (newValue === 1) {
      setImlTab("unFocus");
      setSTab("focus");
      setDsTab("unFocus");
    }
    if (newValue === 2) {
      setImlTab("unFocus");
      setSTab("unFocus");
      setDsTab("focus");
    }
  };

  const handleChangeIndex = (index) => {
    sessionStorage.setItem('dataActiveTab', index);
    setValue(index);
    if (index === 0) {
      setImlTab("focus");
      setSTab("unFocus");
      setDsTab("unFocus");
    }
    if (index === 1) {
      setImlTab("unFocus");
      setSTab("focus");
      setDsTab("unFocus");
    }
    if (index === 2) {
      setImlTab("unFocus");
      setSTab("unFocus");
      setDsTab("focus");
    }
  };

  //This function is for handle change Tab focusable end

  //This function is for Station Tab focusable Start
  const tabStationTab = () => {
    sessionStorage.setItem('dataActiveTab', 2);
    setValue(2);
    setImlTab("unFocus");
    setSTab("focus");
    setDsTab("unFocus");
  }
  //This function is for Station Tab focusable End

  //This function is for Return Station Tab focusable Start
  const returnStationTab = () => {
    sessionStorage.setItem('dataActiveTab', 1);
    setValue(1);
    setImlTab("unFocus");
    setSTab("focus");
    setDsTab("unFocus");
  }
  //This function is for Return Station Tab focusable End

  //This function is for Return Station Tab focusable Start
  const stationDetailsTab = (id,delete_flag) => {
    sessionStorage.setItem('dataActiveTab', 3);
    sessionStorage.setItem('viewStationId', id);
    sessionStorage.setItem('deleteFlag', delete_flag);
    setValue(3);
    setImlTab("unFocus");
    setSTab("focus");
    setDsTab("unFocus");
  }
  //This function is for Return Station Tab focusable End

  //This function is for Import Details Tab focusable Start
  const importDetailsTab = sid => {
    sessionStorage.setItem('dataActiveTab', 5);
    sessionStorage.setItem('station_Id', sid);
    setValue(5);
    setImlTab("focus");
    setSTab("unFocus");
    setDsTab("unFocus");
  }
  //This function is for Import Details Tab focusable End

  //This function is for Return Import List Tab focusable Start
  const returnImportDetailsTab = () => {
    sessionStorage.setItem('dataActiveTab', 0);
    setValue(0);
    setImlTab("focus");
    setSTab("unFocus");
    setDsTab("unFocus");
  }
  //This function is for Return Import List Tab focusable End

  //This function is for Station Tab focusable Start
  const tabExportTab = () => {
    sessionStorage.setItem('dataActiveTab', 5);
    setValue(5);
    setImlTab("unFocus");
    setSTab("focus");
    setDsTab("unFocus");
  }
  //This function is for Station Tab focusable End

  return (
    <React.Fragment>
      <div className={classes.mainBlock}>
        <h4>Data Management</h4>
        <hr style={{ marginTop: '0px' }} />
        <div className={classes.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="Import List" {...a11yProps(0)} className={imlTab} />
              <Tab label="Stations" {...a11yProps(1)} className={sTab} data-testid="stationListTab" />
              <Tab label="Add New Station" {...a11yProps(2)} className={classes.nonTab} />
              <Tab label="Station Details" {...a11yProps(3)} className={classes.nonTab} />
              <Tab label="Import Details" {...a11yProps(4)} className={classes.nonTab} />
              <Tab label="Export Station" {...a11yProps(5)} className={classes.nonTab} />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDiv} style={{ height: screenDMHeight.toString() + 'px' }}>
                <ImportList focusImportDetails={importDetailsTab} />
              </div>
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDiv} style={{ height: screenDMHeight.toString() + 'px' }}>
                <Stations tabStationValue={tabStationTab} stationDetailsTab={stationDetailsTab} tabExportTab={tabExportTab} />
              </div>
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDivSecond} style={{ height: screenDMHeight.toString() + 'px' }}>
                <AddNewStation stationtabBack={returnStationTab} />
              </div>
            </TabPanel>
            <TabPanel value={value} index={3} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDivSecond} style={{ height: screenDMHeight.toString() + 'px' }}>
                <StationDetails stationtabBack={returnStationTab} />
              </div>
            </TabPanel>
            <TabPanel value={value} index={4} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDivSecond} style={{ height: screenDMHeight.toString() + 'px' }}>
               <></>
              </div>
            </TabPanel>
            <TabPanel value={value} index={5} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDivSecond} style={{ height: screenDMHeight.toString() + 'px' }}>
               <ExportStations stationtabBack={returnStationTab} />
              </div>
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
    </React.Fragment>
  );
}